module.exports = __webpack_public_path__ + "img/p3.32ff97da.png";